import { Injectable, Renderer2, RendererFactory2, inject, DOCUMENT } from '@angular/core';

import { SharedSignalsService } from './shared-signals.service';
import { AuthService } from './auth.service';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { LocalStorageService } from './local-storage.service';
import { SessionVariable } from '../enum/session-variable';
import { ActivatedRoute, Router } from '@angular/router';
import { EnvService } from '../../env.service';

@Injectable({
  providedIn: 'root',
})
export class ExternalScriptsService {
  private document = inject(DOCUMENT);
  private rendererFactory = inject(RendererFactory2);
  private storageService = inject(LocalStorageService);
  private activatedRoute = inject(ActivatedRoute);
  private router = inject(Router);
  private authService = inject(AuthService);
  public envService = inject(EnvService);
  private ngxService = inject(NgxUiLoaderService);

  private renderer: Renderer2;
  orderDetails: any;

  transferSignal = inject(SharedSignalsService);

  constructor() {
    this.renderer = this.rendererFactory.createRenderer(null, null);
  }

  loadScript(scriptUrl: string, callback: () => void): void {
    const script = this.renderer.createElement('script');
    script.type = 'text/javascript';
    script.src = scriptUrl;
    script.onload = callback;

    this.renderer.appendChild(this.document.body, script);
  }

  initTapSDKs(user: any): void {
    this.orderDetails = user;

    if (!user) {
      return;
    }

    const {
      renderApplePayButton,
      Scope,
      SupportedNetworks,
      Locale,
      ButtonType,
      Environment,
      ThemeMode,
      Edges,
    } = (window as any).TapSDKs;

    renderApplePayButton(
      {
        publicKey: 'pk_live_4h2AcjLUvsR5yBxbo6frGXe1',
        environment: Environment.Development,
        scope: Scope.TapToken,
        merchant: {
          domain: 'www.dev-taly.io',
          id: 'merchant_fOhl5224538qed69EZ1e846',
        },

        interface: {
          locale: Locale.EN,
          theme: ThemeMode.DARK,
          type: ButtonType.PAY,
          edges: Edges.CURVED,
        },
        transaction: {
          currency: 'KWD',
          amount: user?.amount,
        },
        acceptance: {
          supportedBrands: [SupportedNetworks.Visa, SupportedNetworks.MasterCard],
          supportedCards: 'ALL',
          supportedCardsWithAuthentications: ['3DS'],
        },
        customer: {
          id: null,
          name: [
            {
              locale: 'en',
              first: user?.firstName,
              last: user?.lastName,
            },
          ],
          contact: {
            email: user?.emailAddress,
            phone: {
              number: user?.mobileNumber,
              countryCode: user?.countryCode,
            },
          },
        },
        onCancel: async () => {
          // this.ngxService.stop();
          // this.transferSignal.showMessage('Payment cancelled : > ', error);
        },
        onError: async () => {
          //this.transferSignal.showMessage('Payment error > ', error);
          //this.ngxService.stop();
        },
        onSuccess: async (data: any) => {
          this.applePay(data?.id);
        },
        onReady: async () => {
          console.groupEnd();
        },
        onClick: async () => {
          //this.ngxService.start();
        },
      },
      'apple-pay-button'
    );
  }

  applePay(tokenId: any) {
    const payload = {
      orderToken: this.orderDetails?.orderToken,
      paymentPlanId: this.orderDetails?.paymentPlanId ?? 'THREE_MONTHS',
      paymentMethod: 'APPLEPAY',
      paymentType: 'DOWNPAYMENT',
      tokenId: tokenId,
    };

    this.authService.payByApplePay(payload).subscribe(
      (res) => {
        this.storageService.setItem(SessionVariable.PAID_BY_APPLE_PAY, true);
        if (res?.redirectUrl) {
          this.transferSignal.setMerchantRedirectUrl(res?.redirectUrl);
        }
        this.storageService.setItem(SessionVariable.PAYMENT_REFERENCE, res?.paymentReference);
        this.ngxService.stopLoader('master');
        if (res.orderStatus == 'CONFIRMED' && res.paymentStatus == 'CAPTURED') {
          this.router.navigate(['/secure-checkout/', payload.orderToken, 'payment', 'success']);
        } else {
          this.storageService.setItem(
            SessionVariable.FAIL_ERROR_MSG,
            `Payment Reference ${res?.paymentReference} is ${res?.paymentStatus}`
          );
          this.router.navigate(['/secure-checkout/', payload.orderToken, 'payment', 'error']);
        }
        //this.storageService.removeItem(SessionVariable.AUTO_PAY);
      },
      (err) => {
        this.router.navigate(['../payment/reject'], {
          state: { allowRetry: true },
          relativeTo: this.activatedRoute,
        });
        this.transferSignal.showMessage('Payment cancelled : > ', err?.message || err);
      }
    );
  }
}
